import { getJSON } from "../request";

const isProd = process.env.NODE_ENV === "production";

// 机构入驻页面配置
export const getOrgSettledJson = () =>
  getJSON(
    `https://cdn.moguocdn.com/${isProd ? "" : "Test/"}cdn/json/org-settled.json`
  );
